// extracted by mini-css-extract-plugin
export default {"wrapper":"BatteryStatus_wrapper__4drTx"};